// src/components/shared/EditTripDialog.vue
<script setup>
import { useDataStore } from '@/stores/data'
import { useMapStore } from '@/stores/map'
import { useAppStore } from '@/stores/app'
import { watch } from 'vue'

const dataStore = useDataStore()
const mapStore = useMapStore()
const appStore = useAppStore()

const props = defineProps({
	show: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits(['close'])

const close = () => {
	emit('close')
}

const deleteTrip = () => {
	dataStore.deleteTrip(dataStore.currentTrip)
	close()
}

const changeLocation = (type) => {
	console.warn('changeLocation', type)
	appStore.bottomSheet.close()
	dataStore.currentLocationType = type
	dataStore.showGeocoder = true
	dataStore.showEditTripDialog = false
}

const saveTrip = () => {
	dataStore.saveTrip()
	mapStore.plotTrips()
	close()
}

const fetchLocationDescription = async (locationType) => {
	const location = dataStore.currentEditTrip[locationType]
	const response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${location.longitude},${location.latitude}.json?access_token=${mapStore.accessToken}&language=no`)
	const data = await response.json()
	var firstFeature = data.features[0]
	var description = firstFeature.text
	var locationContext = firstFeature?.context
	if (locationContext) {
		locationContext.forEach((context) => {
			if (context.id.includes('postcode')) {
				description += ', ' + context.text
			}
			if (context.id.includes('place')) {
				description += ' ' + context.text
			}
		})
	}

	console.log('fetchLocationDescription', locationType, data, description)
	return description
}

const fetchOriginAndDestinationDescription = async () => {
	dataStore.currentEditTrip.origin.title = await fetchLocationDescription('origin')
	dataStore.currentEditTrip.destination.title = await fetchLocationDescription('destination')
}

watch(
	() => props.show,
	(newVal) => {
		if (newVal) {
			console.log('Dialog is now shown')
			fetchOriginAndDestinationDescription()
			// Add any additional logic you want to execute when show becomes true
		}
	},
)
</script>

<template>
	<div v-if="show" class="dialog-overlay" @click.self="close">
		<div class="dialog-container">
			<div class="dialog-content">
				<div class="dialog-header">
					<h5 class="dialog-title">Rediger tur</h5>
					<div class="button close" @click="close">
						<i class="fa-solid fa-xmark"></i>
					</div>
				</div>

				<div class="dialog-body">
					<div class="mb-4 mt-1">
						<strong>Transportmiddel for denne delreisen</strong>
						<div class="flex flex-wrap gap-2 mt-2">
							<div v-for="mode in dataStore.transportModes" :key="mode.type" class="button pr-3 pl-3 transportButton" :class="[mode.type, { selected: dataStore.currentEditTrip?.activity_name === mode.type }]" @click="dataStore.currentEditTrip.activity_name = mode.type">
								<span class="badge badge-pill activity" :class="[mode.type]">
									<i class="fas fa-circle"></i>
								</span>
								{{ mode.name }}
							</div>
						</div>
					</div>

					<div class="flex gap-2">
						<div>
							<label for="startTime"><strong>Tid Avreise</strong></label>
							<div class="input-group mb-3">
								<input id="startTime" type="time" class="form-control" v-model="dataStore.currentEditTrip.startTime" placeholder="HH:mm" />
							</div>
						</div>
						<div>
							<label for="endTime"><strong>Tid Ankomst</strong></label>
							<div class="input-group mb-3">
								<input id="endTime" type="time" class="form-control" v-model="dataStore.currentEditTrip.endTime" placeholder="HH:mm" />
							</div>
						</div>
					</div>

					<div class="mb-2">
						<label for="startTime"><strong>Avreisested</strong></label>
						<div class="place form-control mt-1" @click="changeLocation('origin')">
							<template v-if="!dataStore.currentEditTrip.origin.title">Endre posisjon</template>
							<template v-else>
								<div class="title">{{ dataStore.currentEditTrip.origin.title }}</div>
								<div class="subtitle">{{ dataStore.currentEditTrip.origin.subTitle }}</div>
							</template>
						</div>
					</div>

					<div class="mb-4">
						<label for="startTime"><strong>Reisemål</strong></label>
						<div class="place form-control mt-1" @click="changeLocation('destination')">
							<template v-if="!dataStore.currentEditTrip.destination.title">Endre posisjon</template>
							<template v-else>
								<div class="title">{{ dataStore.currentEditTrip.destination.title }}</div>
								<div class="subtitle">{{ dataStore.currentEditTrip.destination.subTitle }}</div>
							</template>
						</div>
					</div>

					<div class="mb-2 mt-1" v-if="appStore.testerMode">
						<strong>Kommentar</strong>
						<div class="d-flex flex-wrap mt-2">
							<textarea class="form-control" v-model="dataStore.currentEditTrip.comment" placeholder="Skriv en kommentar til denne delreisen" rows="3"></textarea>
						</div>
					</div>
				</div>

				<div class="dialog-footer">
					<div class="button red" @click="deleteTrip">
						{{ dataStore.currentEditTrip?.deleted ? 'Angre sletting' : 'Slett' }}
					</div>
					<div class="button green" @click="saveTrip">Lagre</div>
				</div>
			</div>
		</div>
	</div>
</template>
